import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { HttpParamNames } from 'src/app/core/constantes/http_param-names';
import { Context } from '../../models/server/core/context';
import { FilterInfos } from '../../models/server/core/filter-infos';
import { Results } from '../../models/server/core/results-T';
import { SortInfos } from '../../models/server/core/sort-infos';
import { Customer } from '../../models/server/customer';
import { AdvancedService } from '../core/advanced.service';
import { ConnectedUsersStateService } from '../state/connected-users-state.service';
import { ServiceBase } from './service-base';

@Injectable({
    providedIn: 'root',
})
export class CustomersService extends ServiceBase implements AdvancedService<Customer> {
    constructor(
        private http: HttpClient,
        public override connectedUserStateService: ConnectedUsersStateService
    ) {
        super(connectedUserStateService);
    }

    /**
     * Liste des bannettes
     * @param context : Context
     * @param filters : Information pour le filtre
     * @param sortInfos : Information pour le tri
     * @param pageNumber : Numéro de la page
     * @param pageSize : Nombre d'élément sur la page
     * @returns Liste de bannettes
     */
    public List(context: Context, filters: FilterInfos[], sortInfos: SortInfos, pageNumber = 0, pageSize = 100): Observable<Results<Customer>> {
        const httpOptions = {
            headers: new HttpHeaders({
                'Content-Type': 'application/json',
                sort: this.getHeader(sortInfos),
                filters: this.getHeader(filters),
                context: this.getHeader(context),
            }),
            params: new HttpParams().set(HttpParamNames.FROM, pageNumber.toString()).set(HttpParamNames.SIZE, pageSize.toString()),
        };

        return this.http.get(this.baseUrl + `/api/organizations/${this.organizationId}/customers`, httpOptions).pipe(
            map((x) => {
                var res = Results.getCopyFrom<Customer>(Customer, x);
                return res;
            })
        );
    }
}
